import { useCalculator } from '../state/CalculatorProvider';

/**
 * Group-aware: steps that share a `group` label render as one progress
 * tick. HW Index is 21 screens across 8 groups — "STEP n OF 8", not 21.
 * See docs/calculator-engine-architecture.md §3.1.
 */
export function StepProgress() {
  const { config, state, derived } = useCalculator();

  if (!config.progress || config.progress === 'none' || state.phase !== 'steps') {
    return null;
  }

  const groups: string[] = [];
  for (const step of derived.visibleSteps) {
    const g = step.group ?? step.id;
    if (groups[groups.length - 1] !== g) groups.push(g);
  }

  const currentGroup = derived.currentStep ? (derived.currentStep.group ?? derived.currentStep.id) : null;
  const activeIndex = currentGroup ? groups.indexOf(currentGroup) : -1;

  return (
    <div
      className="hsab-calc__progress"
      role="progressbar"
      aria-valuenow={activeIndex + 1}
      aria-valuemin={1}
      aria-valuemax={groups.length}
      aria-live="polite"
    >
      <span className="hsab-calc__progress-label">
        STEP {activeIndex + 1} OF {groups.length}
      </span>
      <div className="hsab-calc__progress-ticks" aria-hidden="true">
        {groups.map((g, i) => (
          <span
            key={g}
            className={
              i === activeIndex
                ? 'hsab-calc__progress-tick hsab-calc__progress-tick--active'
                : 'hsab-calc__progress-tick'
            }
          />
        ))}
      </div>
    </div>
  );
}
